import type { Action, Nullable } from '../model'

import createReducer from '../createReducer'
import { Actions, ITheme } from './types'






export interface ThemeReducer {
  theme: Nullable<ITheme>
}

const defaultState: ThemeReducer = {
  theme: null,
}

export const themeReducer = createReducer<ThemeReducer>(defaultState, {
  [Actions.SET_THEME]: (state: Nullable<ThemeReducer>, action: Action<Nullable<ITheme>>) => ({
    ...state,
    theme: action.payload,
  }),
})
